// import React, { useState } from 'react'
// import axios from 'axios'
// import Swal from 'sweetalert2'
// import Logo from '../Assets/Assests/Logos/Final - logo ---Photoroom 2.png'
// import { useNavigate } from 'react-router-dom'

// const SignIn = () => {
//   const navigate = useNavigate()
//   const [email, setEmail] = useState('')
//   const [password, setPassword] = useState('')
//   const [loading, setLoading] = useState(false)

//   const handleSignIn = async (e) => {
//     e.preventDefault()

//     if (!email || !password) {
//       Swal.fire({
//         icon: 'warning',
//         title: 'Incomplete Fields',
//         text: 'Please fill out both email and password.',
//       })
//       return
//     }

//     setLoading(true)

//     try {
//       const response = await axios.post(
//         'https://aimuseumbackend.teslabird.com/auth/login/',
//         {
//           email,
//           password,
//         }
//       )

//       Swal.fire({
//         icon: 'success',
//         title: 'Login Successful',
//         text: `Welcome back, ${email}!`,
//       })

//       const payload = response.data
//       localStorage.setItem('refresh', payload.refresh)
//       localStorage.setItem('access', payload.access)
//       localStorage.setItem('jwt_token', payload.jwt_token)
//       localStorage.setItem('username', payload.username)
//       localStorage.setItem('email', payload.email)
//       localStorage.setItem('role', payload.role)

//       // Redirect based on user role
//       if (payload.role === 'Secondary') {
//         navigate('/secondary-form')
//       } else if (payload.role === 'Higher_Secondary') {
//         navigate('/higher-secondary')
//       } else if (payload.role === 'UGPG') {
//         navigate('/ugpg')
//       } else if (payload.role === 'working') {
//         navigate('/working-professionals')
//       } else {
//         navigate('/unauthorized') // Default route if no match
//       }
//     } catch (error) {
//       Swal.fire({
//         icon: 'error',
//         title: 'Login Failed',
//         text:
//           error.response?.data?.message ||
//           'Something went wrong. Please try again.',
//       })
//     } finally {
//       setLoading(false)
//     }
//   }

//   const handleForgotPassword = async () => {
//     if (!email) {
//       Swal.fire({
//         icon: 'warning',
//         title: 'Email Required',
//         text: 'Please enter your email to reset your password.',
//       })
//       return
//     }

//     try {
//       const response = await axios.post(
//         'https://aimuseumbackend.teslabird.com/auth/forgot-password/',
//         {
//           email,
//         }
//       )

//       Swal.fire({
//         icon: 'success',
//         title: 'Email Sent',
//         text: 'A password reset link has been sent to your email address.',
//       })
//       navigate('/resend-password', { state: { email: email } })
//       // console.log('Forgot Password Response:', response.data)
//     } catch (error) {
//       Swal.fire({
//         icon: 'error',
//         title: 'Request Failed',
//         text:
//           error.response?.data?.message ||
//           'Unable to send reset email. Please try again.',
//       })
//     }
//   }

//   return (
//     <div
//       className='container-fluid min-vh-100'
//       style={{ backgroundColor: '#B02013' }}
//     >
//       <div className='row align-items-center justify-content-center min-vh-100'>
//         <div className='col-12 col-md-6 text-center mb-4 mb-md-0'>
//           <img src={Logo} className='img-fluid' style={{ maxWidth: '300px' }} />
//         </div>
//         <div className='col-12 col-md-6 col-lg-4'>
//           <div className='card border-0 shadow-lg rounded-4 p-4'>
//             <div className='card-body'>
//               <h2 className='card-title mb-4 fw-bold'>Sign in</h2>
//               <p className='text-muted mb-4'>
//                 Don’t have an account?{' '}
//                 <a
//                   href='/sign-up'
//                   className='text-decoration-none'
//                   style={{ color: 'black' }}
//                 >
//                   Register here!
//                 </a>
//               </p>
//               <form onSubmit={handleSignIn}>
//                 <div className='mb-3'>
//                   <label className='form-label text-muted small'>Email</label>
//                   <div className='input-group'>
//                     <span className='input-group-text border-0 bg-transparent'>
//                       <i className='bi bi-envelope'></i>
//                     </span>
//                     <input
//                       type='email'
//                       className='form-control border-0 border-bottom'
//                       placeholder='Enter your email address'
//                       value={email}
//                       onChange={(e) => setEmail(e.target.value)}
//                       style={{ color: '#000' }}
//                     />
//                   </div>
//                 </div>
//                 <div className='mb-4'>
//                   <label className='form-label text-muted small'>
//                     Password
//                   </label>
//                   <div className='input-group'>
//                     <span className='input-group-text border-0 bg-transparent'>
//                       <i className='bi bi-lock'></i>
//                     </span>
//                     <input
//                       type='password'
//                       className='form-control border-0 border-bottom'
//                       placeholder='Enter your password'
//                       value={password}
//                       onChange={(e) => setPassword(e.target.value)}
//                       style={{ color: '#000' }}
//                     />
//                     <span className='input-group-text border-0 bg-transparent'>
//                       <i className='bi bi-eye'></i>
//                     </span>
//                   </div>
//                 </div>
//                 <div className='d-flex justify-content-between align-items-center mb-4'>
//                   <div className='form-check'>
//                     <input
//                       type='checkbox'
//                       className='form-check-input'
//                       id='rememberMe'
//                     />
//                     <label
//                       className='form-check-label text-muted small'
//                       htmlFor='rememberMe'
//                     >
//                       Remember Me
//                     </label>
//                   </div>
//                   <button
//                     type='button'
//                     onClick={handleForgotPassword}
//                     className='btn btn-link text-decoration-none small'
//                     style={{ color: '#2D1B3E', padding: 0 }}
//                   >
//                     Forgot Password?
//                   </button>
//                 </div>
//                 <button
//                   type='submit'
//                   className='btn w-100 text-white py-2 rounded-pill'
//                   style={{ backgroundColor: '#B02013' }}
//                   disabled={loading}
//                 >
//                   {loading ? 'Signing In...' : 'Sign In'}
//                 </button>
//               </form>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   )
// }

// export default SignIn

import React, { useState } from 'react'
import axios from 'axios'
import Swal from 'sweetalert2'
import Logo1 from '../Assets/Assests/Logos/Tesla Bird -1 1.png'
import { useNavigate } from 'react-router-dom'
import {
  Form,
  Button,
  Card,
  Container,
  Row,
  Col,
  InputGroup,
} from 'react-bootstrap'
import {
  IoMailOutline,
  IoLockClosedOutline,
  IoEyeOutline,
} from 'react-icons/io5'
import Signin from '../Assets/screens/SigninVector.png'
import AiLogo1 from '../Assets/Assests/Logos/Tesla bird logo.png'

const SignIn = () => {
  const navigate = useNavigate()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)

  const handleSignIn = async (e) => {
    e.preventDefault()

    if (!email || !password) {
      Swal.fire({
        icon: 'warning',
        title: 'Incomplete Fields',
        text: 'Please fill out both email and password.',
      })
      return
    }

    setLoading(true)

    try {
      const response = await axios.post(
        'https://aimuseumbackend.teslabird.com/auth/login/',
        {
          email,
          password,
        }
      )

      Swal.fire({
        icon: 'success',
        title: 'Login Successful',
        text: `Welcome!`,
      })

      const payload = response.data

      // Store relevant tokens/data
      localStorage.setItem('refresh', payload.refresh)
      localStorage.setItem('access', payload.access)
      localStorage.setItem('jwt_token', payload.jwt_token)
      localStorage.setItem('username', payload.username)
      localStorage.setItem('email', payload.email)
      localStorage.setItem('role', payload.role)
      localStorage.setItem('status', payload.is_member)
      localStorage.setItem('form_status', payload.is_FormSubmitted)

      navigate('/home')
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Login Failed',
        text:
          error.response?.data?.msg ||
          'Something went wrong. Please try again.',
      })
    } finally {
      setLoading(false)
    }
  }

  const handleForgotPassword = async () => {
    if (!email) {
      Swal.fire({
        icon: 'warning',
        title: 'Email Required',
        text: 'Please enter your email to reset your password.',
      })
      return
    }

    try {
      const response = await axios.post(
        'https://aimuseumbackend.teslabird.com/auth/forgot-password/',
        {
          email,
        }
      )

      Swal.fire({
        icon: 'success',
        title: 'Email Sent',
        text: 'A password reset link has been sent to your email address.',
      })
      navigate('/resend-password', { state: { email: email } })
      // console.log('Forgot Password Response:', response.data)
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Request Failed',
        text:
          error.response?.data?.message ||
          'Unable to send reset email. Please try again.',
      })
    }
  }

  return (
    <Container
      fluid
      className='min-vh-100 d-flex'
      // style={{ backgroundColor: '#B02013' }}
    >
      <Row className='w-100'>
        {/* Left Side - Hidden on Small Screens */}
        <Col
          md={6}
          className='d-none d-md-flex flex-column align-items-center justify-content-center text-white'
          style={{ backgroundColor: '#DDEEFC' }}
        >
          {/* Logo for Large Screens (Top-Left) */}
          <div
            className='d-flex align-items-center'
            style={{ position: 'absolute', top: '0', left: '0' }}
          >
            <a href='/'>
              <img
                src={AiLogo1}
                alt='Museum Logo'
                className='me-2'
                width={80}
                height={80}
                style={{
                  marginRight: '20px',
                  marginLeft: '20px',
                  marginTop: '15px',
                }}
              />
            </a>
            {/* <img
              src={Logo}
              alt='Logo'
              className='mb-4 d-none d-md-block'
              style={{ width: '150px', marginRight: '20px' }} // Adjust margin for spacing
            />
            <img
              src={AiLogo}
              alt='AiLogo'
              className='mb-4 d-none d-md-block'
              style={{ width: '150px' }}
            /> */}
          </div>
          <img
            src={Signin}
            alt='Illustration'
            className='img-fluid'
            style={{ maxWidth: '350px' }}
          />
        </Col>

        {/* Right Side - Sign In Form */}
        <Col
          xs={12}
          md={6}
          className='d-flex flex-column align-items-center justify-content-center p-4'
          style={{ backgroundColor: '#fff' }}
        >
          {/* Logo for Small Screens */}
          <img
            src={Logo1}
            alt='Logo'
            className='img-fluid d-block d-md-none mb-3'
            style={{ width: '120px' }}
          />

          <Card
            className='shadow-lg rounded-4 p-2'
            style={{ width: '100%', maxWidth: '400px' }}
          >
            <Card.Body>
              <h2 className='fw-bold mb-3'>Sign in</h2>
              {/* <p className='text-muted'>
                If you don’t have an account,{' '}
                <a href='/sign-up' className='text-decoration-none fw-bold'>
                  Register here!
                </a>
              </p> */}

              <Form onSubmit={handleSignIn}>
                {/* Email Input */}
                <Form.Group className='mb-3'>
                  <Form.Label className='text-muted small'>Email</Form.Label>
                  <InputGroup>
                    <InputGroup.Text className='bg-transparent border-0'>
                      <IoMailOutline size={20} color='black' />
                    </InputGroup.Text>
                    <Form.Control
                      type='email'
                      placeholder='Enter your email address'
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      className='border-0 border-bottom'
                      style={{ color: 'black' }}
                    />
                  </InputGroup>
                </Form.Group>

                {/* Password Input */}
                <Form.Group className='mb-3'>
                  <Form.Label className='text-muted small'>Password</Form.Label>
                  <InputGroup>
                    <InputGroup.Text className='bg-transparent border-0'>
                      <IoLockClosedOutline size={20} color='black' />
                    </InputGroup.Text>
                    <Form.Control
                      type='password'
                      placeholder='Enter your password'
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      className='border-0 border-bottom'
                      style={{ color: 'black' }}
                    />
                  </InputGroup>
                </Form.Group>

                {/* Remember Me & Forgot Password */}
                <div className='d-flex justify-content-between align-items-center mb-4'>
                  {/* Checkbox with Label Alignment */}
                  <div className='d-flex align-items-center gap-2'>
                    {/* <button
                      type='button'
                      onClick={handleForgotPassword}
                      className='text-muted small text-decoration-none'
                      style={{
                        background: 'none',
                        border: 'none',
                        padding: 0,
                        color: '#6c757d',
                      }}
                    >
                      Forgot Password?
                    </button> */}
                  </div>

                  {/* Forgot Password & Admin Login Links */}
                  {/* <div className='d-flex gap-3'>
                    <a
                      href='/admin-signin'
                      className='text-primary small text-decoration-none'
                      style={{ color: '#6c757d' }}
                    >
                      Admin Login
                    </a>
                  </div> */}
                </div>

                {/* Login Button */}
                <Button
                  type='submit'
                  className='w-100 text-white rounded-pill'
                  style={{ backgroundColor: ' #002740' }}
                  disabled={loading}
                >
                  {loading ? 'Signing In...' : 'Login'}
                </Button>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  )
}

export default SignIn
